import axios from '@/client/core/api'
import { TCampaign } from '@/typings/api/campaigns.type'

/**
 * キャンペーン情報を取得
 *
 * @param campaignId - キャンペーンID
 * @returns キャンペーン情報
 * @throws キャンペーンIDが不正、またはデータ取得に失敗した場合にエラーをthrow
 *
 * @example
 * const campaign = await getCampaign(123)
 */
export async function getCampaign(campaignId: number): Promise<TCampaign> {
  const result = await axios.get(`/campaigns/${campaignId}`)

  return result.data as TCampaign
}
